import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import {
  CartHistoryHeader,
  CartsDisplay,
  DealsNag,
  HolidayModal,
  LoadingCart,
  WelcomeModal,
} from 'src/components';
import {
  useAssociateCartCookie,
  useCartListQuery,
  useCurrentUser,
  useDebounce,
} from 'src/hooks';
import {
  cartImportPendingAtom,
  historyFilterByAtom,
  historySearchByAtom,
  showCartsImportedModalAtom,
} from 'src/store';

let defaultHistoryFilterBySet = false;

export const CartHistory = () => {
  const { user } = useCurrentUser();
  const [, setHistoryFilterBy] = useAtom(historyFilterByAtom);
  const [searchBy] = useAtom(historySearchByAtom);
  const [cartImportPending] = useAtom(cartImportPendingAtom);
  const [, setShowCartsImportedModal] = useAtom(showCartsImportedModalAtom);
  const [isListView, setIsListView] = useState<boolean>(true);
  const [displayedCartsLength, setDisplayedCartsLength] = useState<
    number | null
  >(null);

  const [debounceDelay, setDebounceDelay] = useState<number>(1000);
  const debouncedSearchBy = useDebounce(searchBy, debounceDelay);

  useAssociateCartCookie();

  // Set default filter for org admin/approver once per visit (page is behind auth so user is present).
  useEffect(() => {
    if (!user) {
      return;
    }

    const isOrgAdminOrApprover =
      user.subscription?.tier === 'organization' &&
      (user.subscription?.role === 'admin' ||
        user.subscription?.role === 'approver');

    if (isOrgAdminOrApprover && !defaultHistoryFilterBySet) {
      setHistoryFilterBy('all_org');
      defaultHistoryFilterBySet = true;
    }
  }, [user, setHistoryFilterBy]);

  const cartsQuery = useCartListQuery({ debouncedSearchBy });

  useEffect(() => {
    if (!cartsQuery.isLoading) {
      setDisplayedCartsLength(
        cartsQuery.data?.pages.reduce(
          (acc, { carts }) => acc + carts.length,
          0,
        ) || 0,
      );
    }
  }, [cartsQuery]);

  useEffect(() => {
    if (cartImportPending) {
      setShowCartsImportedModal(true);
    }
  }, [cartImportPending, setShowCartsImportedModal]);

  return (
    <>
      <CartHistoryHeader
        cartsQuery={cartsQuery}
        displayedCartsLength={displayedCartsLength || 0}
        isListView={isListView}
        setIsListView={setIsListView}
        setDebounceDelay={setDebounceDelay}
      />
      {cartsQuery.isLoading || displayedCartsLength === null ? (
        <div className='mx-auto w-full border-b border-blueGray pb-4'>
          <div className='mx-auto w-40'>
            <LoadingCart
              customTextColor={'text-primary-dark'}
              customBgColor='bg-transparent'
            />
          </div>
        </div>
      ) : (
        <CartsDisplay
          cartsList={cartsQuery.data?.pages || undefined}
          displayedCartsLength={displayedCartsLength || 0}
          isListView={isListView}
          queryError={cartsQuery.isError}
          loadMoreCarts={cartsQuery.fetchNextPage}
          fetchingNextPage={cartsQuery.isFetchingNextPage}
          hasNextPage={cartsQuery.hasNextPage}
        />
      )}

      <WelcomeModal />
      {/* <BetaEndModal /> */}
      <HolidayModal />
      <DealsNag source='nag-history' deferToWelcomeModal />
    </>
  );
};
